<template>
  <div>
    <el-button class="btn" plain type="primary" @click="addBound">增加绑定</el-button>
    <el-table v-loading="loading" :data="tableData" max-height="500" border style="width: 100%">
      <el-table-column prop="corp_name" label="企业" width="280" align="center" />
      <el-table-column prop="corn_time_text" label="汇报时间" width="280" align="center" />
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="editConfig(scope.row)">修改</el-button>
          <el-button type="danger" size="mini" @click="deleteaccount(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right :current-page="pageIfon.page" :total="total" @size-change="fetchPageSize" @current-change="fetchCurrentPage" />

    <el-dialog :title="edit ? '修改绑定信息' : '更新绑定信息'" :close-on-click-modal="false" :visible.sync="changeDialog" :destroy-on-close="true" :append-to-body="true" width="28%">
      <div>
        <changingDialog ref="changedialogview" :report_template_id="pageIfon.report_template_id" @update="update" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { boundList,spReportBinddestroy } from '@/api/tencentAccountIni'
import changingDialog from './changingDialog.vue'

export default {
  components: { PaginationRight, changingDialog },
  data() {
    return {
      total: null,
      loading: false,
      tableData: null,
      pageIfon: {
        report_template_id: null,
        page: 1,
        page_size: 10
      },
      query: {
        id: null,
        corn_day: null,
        corn_time: null
      },
      changeDialog: false,
      edit: false,
      report_id: null
    }
  },
  methods: {
    async send(row) {
      this.pageIfon.report_template_id = row.id
      this.list()
    },
    async list() {
      this.loading = true
      const data = await boundList(this.pageIfon)
      this.total = data.data.total
      this.tableData = data.data.list
      this.loading = false
      console.log('data', data)
    },

    // 修改绑定
    async editConfig(row) {
      this.edit = true
      this.changeDialog = true
      this.$nextTick(() => {
        this.$refs.changedialogview.send(row)
      })
    },
    update() {
      this.changeDialog = false
      this.list()
    },

    // 增加绑定
    addBound() {
      this.edit = false
      this.changeDialog = true
      this.$nextTick(() => {
        this.$refs.changedialogview.send()
      })
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.list()
    },
        // 删除
    deleteaccount(id) {
      this.$confirm('确定要删除当前绑定信息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        spReportBinddestroy({
          id: id
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.list()
          } else {
            this.$message({
              type: 'error',
              message: `${'操作失败，请联系管理员'}`
            })
          }
        })
      })
    },
  }
}
</script>
<style>
.btn {
  float: right;
  margin-bottom: 10px;
}
</style>